<!-- 買う一覧の価格表示 -->
<template>
  <div
    v-if="price"
    class="list-item__price"
    v-html="
      newlineConvert(
        price.replace(/\[BACKSLASH\]/g, '').replace(/\[NL\]/g, '<br>')
      )
    "
  />
</template>

<script>
export default {
  name: "MbsStoreDisplayPriceDisp",
  props: {
    price: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.list-item__price {
  white-space: pre-wrap;
  position: absolute;
  top: 60%;
  color: #777777;
  font-weight: bold;
  font-size: 13px !important;
}
@media screen and (min-width: 421px) {
  .index-content-right {
    height: calc(100vw * (20 / 100));
  }
  .list-item__price {
    font-size: 3.5vw !important;
  }
}
</style>
